export default "__VITE_ASSET__CgUvCsQF__"